<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M17.5 7L7 17.5" stroke="#1B2637" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M7 7L17.5 17.5" stroke="#1B2637" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
